module.exports = __webpack_public_path__ + "static/media/lk.f8d21a6b.svg";